var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"left":"","color":"black"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({attrs:{"size":"18.5","color":"info"}},'v-icon',attrs,false),on),[_vm._v("mdi-face-profile")])]}}])},_vm._l((_vm.selections),function(selection,index){return _c('CategoryChip',{key:index,attrs:{"category":selection}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }